import { Http } from '@angular/http';
import { Component } from '@angular/core';
import { NavController, LoadingController, PopoverController, NavParams, ModalController, ToastController, AlertController } from 'ionic-angular';
import firebase from 'firebase/app';
import { AngularFirestore } from 'angularfire2/firestore';
import { LoadingProvider } from '../../providers/loading/loading';
import { ViewChangeLogPage } from '../view-change-log/view-change-log';
//import undefined from 'firebase/empty-import';

@Component({
  selector: 'page-change-log-profile',
  templateUrl: 'change-log-profile.html',
})
export class ChangeLogProfilePage {
  public email: any;
  public uid: any;
  public count: any;
  public secondary_uid: any;
  public firstname: any;
  public lastname: any;
  public getRole: any;
  public usersList : any = [];
  public data: any;
  public loading: any;
  public contactTotal: number;
  public innerJoinDocument: any;
  public deleted_access: any;
  public notFound: any;
  public personal_details: any;
  public income_details: any;
  public asset_details: any;
  public liability_details: any;
  public realestate_details: any;
  public tentative_realEstate_details: any;
  public personalNotFound: any;
  public incomeNotFound: any;
  public assetsNotFound: any;
  public liabilitiesNotFound: any;
  public realEstateNotFound: any;
  public tentativeRealEstateNotFound: any;

  constructor(
    public navCtrl: NavController,
    public db: AngularFirestore,
    public loadingProvider: LoadingProvider,
    public loadingCtrl: LoadingController,
    public popoverCtrl: PopoverController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public http: Http,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController
  ) {

    this.personalNotFound = '';
    this.incomeNotFound = '';
    this.assetsNotFound = '';
    this.liabilitiesNotFound = '';
    this.realEstateNotFound = '';
    this.tentativeRealEstateNotFound = '';

    this.personal_details = [];
    this.income_details = [];
    this.asset_details = [];
    this.liability_details = [];
    this.realestate_details = [];
    this.tentative_realEstate_details = [];
    let contact_uid = this.navParams.get("contact_uid");
    window.localStorage.removeItem("contact_uid");
    window.localStorage.removeItem("contact_second_uid");
    window.localStorage.removeItem("edit_contact_uid");
    window.localStorage.removeItem("deleted_access");
    window.localStorage.removeItem("generate_new_tentative");
    window.localStorage.removeItem("creating_second");

    let thiss = this;
    this.email = window.localStorage.getItem("email");
    this.uid = window.localStorage.getItem("uid");

    var docRef = firebase.firestore().collection("users").doc(this.uid);

    docRef.get().then(function(doc) {
      if (doc.exists) {
        thiss.presentLoadingText();
        thiss.getAllLogs(contact_uid).subscribe((data)=>{
          if(data.length > 0){
            for(let i = 0; i < data.length; i++) {
              if(data[i].uid == "" || data[i].uid == null || data[i].uid == undefined){}else{
                var docRef1 = firebase.firestore().collection("users").doc(data[i].uid);
                docRef1.get().then(function(doc) {
                  if (doc.exists) {
                    let type = '';
                    if(doc.data().roles.broker == true){
                      type = 'Broker';
                    }else if(doc.data().roles.loan_admin == true){
                      type = 'Loan Admin';
                    }else if(doc.data().roles.super_admin == true){
                      type = 'Super Admin';
                    }else{
                      type = 'Contact';
                    }

                    if(data[i].applicant_details != undefined){
                      if(data[i].applicant_details.length > 0){
                        thiss.personal_details.push({'changed_date': data[i].changed_date, 'name': doc.data().firstname+' '+doc.data().lastname, 'type': type, 'data': data[i].applicant_details}) ;
                      }
                    }
                    if(data[i].income_details != undefined){
                      if(data[i].income_details.length > 0){
                        thiss.income_details.push({'changed_date': data[i].changed_date, 'name': doc.data().firstname+' '+doc.data().lastname, 'type': type, 'data': data[i].income_details}) ;
                      }
                    }
                    if(data[i].asset_details != undefined){
                      if(data[i].asset_details.length > 0){
                        thiss.asset_details.push({'changed_date': data[i].changed_date, 'name': doc.data().firstname+' '+doc.data().lastname, 'type': type, 'data': data[i].asset_details}) ;
                      }
                    }
                    if(data[i].liability_details != undefined){
                      if(data[i].liability_details.length > 0){
                        thiss.liability_details.push({'changed_date': data[i].changed_date, 'name': doc.data().firstname+' '+doc.data().lastname, 'type': type, 'data': data[i].liability_details}) ;
                      }
                    }
                    if(data[i].realEstate_details != undefined){
                      if(data[i].realEstate_details.length > 0){
                        thiss.realestate_details.push({'changed_date': data[i].changed_date, 'name': doc.data().firstname+' '+doc.data().lastname, 'type': type, 'data': data[i].realEstate_details}) ;
                      }
                    }
                    if(data[i].tentative_realEstate_details != undefined){
                      if(data[i].tentative_realEstate_details.length > 0){
                        thiss.tentative_realEstate_details.push({'changed_date': data[i].changed_date, 'name': doc.data().firstname+' '+doc.data().lastname, 'type': type, 'data': data[i].tentative_realEstate_details}) ;
                      }
                    }

                    if(thiss.personal_details.length > 0){
                      thiss.personalNotFound = '';
                    }else{
                      thiss.personalNotFound = 'Change Log not found.';
                    }
                    if(thiss.income_details.length > 0){
                      thiss.incomeNotFound = '';
                    }else{
                      thiss.incomeNotFound = 'Change Log not found.';
                    }
                    if(thiss.asset_details.length > 0){
                      thiss.assetsNotFound = '';
                    }else{
                      thiss.assetsNotFound = 'Change Log not found.';
                    }
                    if(thiss.liability_details.length > 0){
                      thiss.liabilitiesNotFound = '';
                    }else{
                      thiss.liabilitiesNotFound = 'Change Log not found.';
                    }
                    if(thiss.realestate_details.length > 0){
                      thiss.realEstateNotFound = '';
                    }else{
                      thiss.realEstateNotFound = 'Change Log not found.';
                    }
                    
                    if(thiss.tentative_realEstate_details.length > 0){
                      thiss.tentativeRealEstateNotFound = '';
                    }else{
                      thiss.tentativeRealEstateNotFound = 'Change Log not found.';
                    }

                    console.log(thiss.tentativeRealEstateNotFound);
                    
                  } else {
                    console.log("No such document!");
                  }
                }).catch(function(error) {
                  console.log("Error getting document:", error);
                });
              }
            }
            thiss.data = data;
          }else{
            thiss.personalNotFound = 'Change Log not found.';
            thiss.incomeNotFound = 'Change Log not found.';
            thiss.assetsNotFound = 'Change Log not found.';
            thiss.liabilitiesNotFound = 'Change Log not found.';
            thiss.realEstateNotFound = 'Change Log not found.';
            thiss.tentativeRealEstateNotFound = 'Change Log not found.';
          }
          thiss.loading.dismiss();
          
        });
        
      }
    }).catch(function(error) {
      console.log("Error getting document:", error);
    });
  }

  ionViewDidLoad() {
    
  }

  presentLoadingText(){
    this.loading = this.loadingCtrl.create({
      content: 'Loading Please Wait...'
    });
    this.loading.present();
  }
  getAllLogs (contact_uid){
    return this.db.collection<any>( "changed_log" , ref => ref.where('contact_uid', '==', contact_uid).orderBy('changed_date','desc')).valueChanges ();
  }
  viewChangedData(event, document_id){
    this.navCtrl.push(ViewChangeLogPage,{
      document_id:document_id
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/change-log-profile/change-log-profile.ts